//import React from 'react';
import React, { useState,useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Kalash.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import serviceicon from "../../assets/Client/kalash.jpg";
import wedding from "../../assets/Kalash/wedd.JPG";

//import "../Home/Category/Category.scss";
const Kalash = () => {
  const [opacity, setOpacity] = useState(0);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll < lastScrollTop) {
        // Scrolling up
        setOpacity(prev => Math.min(prev + 0.05, 0.7)); // max 70%
      } else{
        // Scrolling down
        setOpacity(prev => Math.max(prev - 0.05, 0)); // min 0%
      }

      setLastScrollTop(currentScroll);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);
  return (
<div style={{backgroundColor:'rgba(0,0,0,2)'}}>
  <div className="service_title10" style={{backgroundColor:'rgba(255,255,255,1)'}}>
      <div className="service_title">
          <img src={serviceicon} className='serviceimg' alt='' />
      </div>
  </div> 
  <div className="image-container"  >
     <img
      src={wedding} // your image URL
      alt="Background"
      className="background-image"
    /> 
          {/* <img src={wedding} alt="the grand machal" style={{width: '100%', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 66.502px)', willChange: 'transform',position:'relative'}} data-speed="0.5" loading="lazy" data-lag="0"></img> */}
          <div className="overlay" style={{ opacity: opacity }}></div>
  </div>
</div>
  );
};
export default Kalash;